import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Tab from "@material-ui/core/Tab";
import {Link} from "react-router-dom";
import {Portfolio,Analytics,Handshake} from "../img/Bottom"
import Hidden from "@material-ui/core/Hidden";
import TransactionAddDialog from "../../../components/TransactionAddDialog";

const useStyles = makeStyles((theme) =>({
    root: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        backgroundColor: "#0B1426",

    },
    action:{
        color: "gray",
        "&.Mui-selected": {
            color: "#fff"
        },
    },
}));

export default function Bottom() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    return (
        <>
            <TransactionAddDialog mobile={true}/>
        <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
                setValue(newValue);
            }}
            showLabels
            className={classes.root}
        >
            <BottomNavigationAction label="Портфель" className={classes.action} icon={<Portfolio />} to={"/portfolio"} component={Link}/>
            <BottomNavigationAction label="Аналитика" className={classes.action} icon={<Analytics />} to={"/analytics"} component={Link}/>
            <BottomNavigationAction label="Сделки" className={classes.action} icon={<Handshake />} to={"/transactions"} component={Link}/>
        </BottomNavigation>

        </>
    );
}
